import React from 'react';

export default function SkeletonRow({ cols = 5, height = '40px', className = '' }) {
  return (
    <tr className={`${className}`} aria-hidden="true">
      {Array.from({ length: cols })?.map((_, i) => (
        <td key={i} className="px-3 py-2">
          <div
            className="skeleton-shimmer rounded"
            style={{
              height: '16px',
              width: i === 0 ? '60%' : i === cols - 1 ? '40%' : `${55 + (i * 13) % 35}%`,
            }}
          />
        </td>
      ))}
    </tr>
  );
}
